import { Image } from '@acme/assets';
import { useCertificates } from '@acme/domains';
import { DropdownSelect } from '@acme/foundation';
import type { Certificate } from 'crypto-pro';
import { mapCertificatesToOptions } from '../lib';
import { Loading } from '../loading';
import { Errors } from './errors';

interface DigitalSignatureProps {
  callback?: (selectedCertificate: Certificate, secret: any) => void;
  title?: string;
  noImage?: boolean;
}

export const DigitalSignature = ({
  callback: successCallback,
  title,
  noImage = false,
}: DigitalSignatureProps) => {
  const { certificates, certificatesError, loading, selectCertificate } =
    useCertificates(successCallback);

  const renderCertificates = () => {
    const options = mapCertificatesToOptions(certificates);

    return (
      <DropdownSelect
        className="w-72"
        options={options}
        placeholder="Выберите КЭП"
        onChange={(thumbprint: string) => selectCertificate(thumbprint)}
      />
    );
  };

  const renderContent = () => {
    if (loading) return <Loading text="Проверяем сертификат КЭП..." />;
    if (certificatesError) {
      return (
        <Errors
          className="pt-20"
          title="Проблема с загрузкой сертификата"
          text={certificatesError.message}
        />
      );
    }
    return <>{renderCertificates()}</>;
  };

  return (
    <>
      {title && !loading && (
        <div className="text-xl w-full font-semibold justify-center text-center flex leading-[normal] mb-6">
          {title}
        </div>
      )}
      {!loading && !certificatesError && !noImage && (
        <div className="flex items-center justify-center w-40 mb-8">
          <Image name="acces" width="100%" className="flex-grow text-center" />
        </div>
      )}
      <div className="w-full flex flex-col items-center">{renderContent()}</div>
    </>
  );
};
